module.exports = __webpack_public_path__ + "img/fondo_navidad.c3367142.png";